import { BackdropBackgroundType } from './types';

export const BACKDROP_COLOR_VARIANTS: Record<
  BackdropBackgroundType,
  string
> = Object.freeze({
  light: 'rgba(25, 25, 25, 0.5)',
  dark: 'rgba(44, 53, 86, 0.7);',
});
